var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1621 14.0994H39.2613C40.6251 14.0994 41.7289 15.2269 41.7289 16.6149L41.7285 30.1199M15.2363 14.0994H14.1531C12.7916 14.0994 11.6855 15.2246 11.6855 16.6149V40.3539C11.6855 41.7419 12.7893 42.8694 14.1531 42.8694H28.8374M38.3369 21.0158H15.0801M16.498 30.0154V25.5401H20.66M24.5117 30.0154V25.5401H28.6737M32.5273 29.3086V25.5401H36.6893M16.498 38.3709V33.8955H20.66M24.5117 38.3709V33.8955H27.9257M23.9961 14.0994H32.1564M34.3125 35.781L37.0058 39.073L39.8861 36.4529M37.0059 45.6198V44.1133M29.8965 38.3755H31.3743M37.0059 31.129V32.6355M44.1125 38.3755H42.6348M32.1562 15.7826V12.4185C32.1562 11.4607 32.9179 10.6865 33.8552 10.6865C34.7948 10.6865 35.5542 11.463 35.5542 12.4185V15.7826C35.5542 16.7404 34.7925 17.5146 33.8552 17.5146C32.9157 17.5146 32.1562 16.7381 32.1562 15.7826ZM21.2574 15.7826V12.4185C21.2574 11.4607 20.4957 10.6865 19.5584 10.6865C18.6188 10.6865 17.8594 11.463 17.8594 12.4185V15.7826C17.8594 16.7404 18.6211 17.5146 19.5584 17.5146C20.4979 17.5146 21.2574 16.7381 21.2574 15.7826ZM38.145 31.2245C42.0189 31.8655 44.6495 35.5866 44.0207 39.5358C43.3919 43.485 39.7417 46.1668 35.8678 45.5258C31.9939 44.8847 29.3633 41.1636 29.9921 37.2144C30.6209 33.2652 34.2711 30.5834 38.145 31.2245Z",
    stroke: "#878686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.943cab970cc228bfb256e046d59afca7.svg";
export { ForwardRef as ReactComponent };